import { useQuery } from '@tanstack/react-query';

import { type RewardsCatalogStatus, fetchCatalogs } from '~/services/LuxLoyalty';

import { rewardsQueryKeys } from './rewardsQueryKeys';

/** Fetches reward catalogs, optionally filtered by itemType and status. */
export function useGetRewardsCatalogs(filters?: { itemType?: string; status?: RewardsCatalogStatus }) {
  return useQuery({
    queryKey: rewardsQueryKeys.catalogsList(filters ?? {}),
    queryFn: () => fetchCatalogs(filters),
  });
}
